import httpService from "@/utils/services/http_service";

export default {
    /**
     * @author: liuxiangmin
     * date: 2020-03-02
     *  管理员列表
     */

    //  获取list
    async filesList(data={}) {
      return httpService.post(
        '/api.php?do=admin_sec_system_files_list',
        data
      )
    },
    // 上传文件
    async fileUpload(data={}) {
      return httpService.upload(
        '/api.php?do=admin_file_upload',
        data
      )
    },
    //  新增文件-提交
    async filesCreate(data={}) {
      return httpService.post(
        '/api.php?do=admin_sec_system_files_create',
        data
      )
    },
    //  删除文件
    async fileDelete(data={}) {
      return httpService.post(
        '/api.php?do=admin_sec_system_files_delete',
        data
      )
    },
    //  更新文件
    async fileEdit(data={}) {
      return httpService.post(
        '/api.php?do=admin_sec_system_files_edit',
        data
      )
    },
    
}